export const COMMERCIAL_SUPPLIERS_TABLE_CAPTION =
  'Summary table of commercial suppliers for the selected substance, showing supplier names, purity, package size, and price. Each row represents a supplier, with options to expand for detailed product information.';

export const PRODUCT_OFFERS_TABLE_CAPTION =
  'Detailed product offerings from a selected supplier, listing available package sizes, purity, prices, shipping times, and availability.';

export const AGGREGATOR_OFFERS_TABLE_CAPTION =
  'Detailed product offerings from a selected supplier, listing supplier names, purity, available package sizes, prices, and shipping times.';

export const AGGREGATOR_PRODUCT_INFORMATION_TABLE_CAPTION =
  'Product information for aggregated supplier offerings, listing supplier names, identification numbers, and product names.';

export const PRICE_SORT_UNAVAILABLE_TOOLTIP = 'Price sorting is available only when all values in the column use the same currency.';

export const COMMERCIAL_SUPPLIER_SORT_DIRECTIONS = {
  asc: 'asc',
  desc: 'desc',
  neutral: 'neutral',
};

export const COMMERCIAL_SUPPLIERS_TABLE_COLUMN_WIDTHS = {
  supplier: '50%',
  purity: '15%',
  size: '12.5%',
  price: '22.5%',
};

export const COMMERCIAL_SUPPLIERS_SELECTED_TABLE_COLUMN = {
  value: 'selected',
  label: '',
  width: '3rem',
  iconOnly: true,
};

export const COMMERCIAL_SUPPLIERS_TABLE_COLUMNS = [
  {
    value: 'supplier',
    label: 'Commercial Suppliers',
    width: COMMERCIAL_SUPPLIERS_TABLE_COLUMN_WIDTHS.supplier,
  },
  {
    value: 'purity',
    label: 'Purity',
    width: COMMERCIAL_SUPPLIERS_TABLE_COLUMN_WIDTHS.purity,
  },
  {
    value: 'size',
    label: 'Size',
    width: COMMERCIAL_SUPPLIERS_TABLE_COLUMN_WIDTHS.size,
  },
  {
    value: 'price',
    label: 'Price',
    width: COMMERCIAL_SUPPLIERS_TABLE_COLUMN_WIDTHS.price,
  },
];

export const INITIAL_VISIBLE_SUPPLIER_COUNT = 7;
export const ALL_VISIBLE_SUPPLIERS_COUNT = Infinity;
export const SUPPLIER_DETAILS_PREVIEW_LIMIT = 7;
export const AGGREGATOR_PREVIEW_LIMIT = 7;
export const COMMERCIAL_DETAILS_SHOW_MORE_THRESHOLD = 100;
export const AGGREGATOR_MODAL_PAGE_SIZE = 15;
export const AGGREGATOR_MODAL_MAX_PAGES_TO_SHOW = 5;
export const AGGREGATOR_MODAL_WIDTH = '59.6875rem';

export const OUTER_TABLE_INITIAL_SORT_BY = 'size';
export const OUTER_TABLE_SORTABLE_COLUMNS = {
  purity: true,
  size: true,
  price: true,
};

export const DEFAULT_DETAIL_SORT_STATE = {
  field: null,
  direction: COMMERCIAL_SUPPLIER_SORT_DIRECTIONS.neutral,
};

export const COMMERCIAL_SUPPLIER_KEY_DELIMITER = '::';
